module.exports = __webpack_public_path__ + "img/1556175409.ab4197c7.jpg";